import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
// import { authenticateByCredentials } from 'actions/Auth'
import AssistanceGovermentView from 'components/publicPages/assistanceGoverment'

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({
  // loginWithCredentials: bindActionCreators(authenticateByCredentials, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('scrollToTop', 'setScrollToTop', false),
  withHandlers({
    handleScrollToTop: props => () => {
      props.setScrollToTop(true)
      setTimeout(() => {
        props.setScrollToTop(false)
      }, 5000)
    },
  }),
  lifecycle({
    componentDidMount() {
      // this.props.handleScrollToTop()
    },

  }),
)(AssistanceGovermentView)
